<script>
// const serverSrc="http://xuexi.test5184.com"
//请求文件
import local_request from './local_request'//引用文件
let serverSrc
if(process.env.NODE_ENV == "development"){
    serverSrc = local_request.serverSrc
}else{
    serverSrc = window.location.protocol + "//" +window.location.host
}
const uDetailData=""                            //全局定义用户数据变量
const identity_list=""                            //全局定义用户数据变量
const pageTimer={}                              //全局定义计时器
const qianzui="/api/v2"                         //请求前缀
const titleAfter=" - 轻松在线课堂"                         //标题尾巴
const activeIndex = 'index'
const oss_link = window.location.protocol+"//oss.qsxueli.com/"
const oss_dir = "xuexi.qsxueli.com"
const oss_website = oss_link+oss_dir		//oss路径       原oss
const sex_arr = [
    {id: 0, title: '保密'},
    {id: 1, title: '男'},
    {id: 2, title: '女'},
]
const join_kaoshi = {
    switch: false,
    is_photograph: false, //是否需要拍照
    photo_num_min:0, //拍照次数最小值
    photo_num_max:0, //拍照次数最大值
    photograph_interval:0,   //拍照间隔（秒）
    is_inspection: false, //是否需要巡考
}
// 白名单页面
const page_whitelist = [
	// 直播页
	'/web/live/room/',
	// 视频试看页
	'/trials/courseInfo',
]
export default {
    serverSrc
    ,uDetailData
    ,identity_list
    ,pageTimer
    ,qianzui
    ,titleAfter
    ,activeIndex
    ,oss_link
    ,oss_dir
    ,oss_website
    ,join_kaoshi
    ,sex_arr
    ,page_whitelist
}
</script>


// WEBPACK FOOTER //
// src/Global.vue